import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import JsonToXlsxDownload from "../utils/JsonToXlsxDownload";
import { Modal, Pagination, notification, Spin as AntSpinner} from "antd";
import {
  CallAddStudentExcel,
  CallFingerprintscanByVendorId,
  CallGetAdminByAdminId,
  CallUpdateUser,
} from "../services/apiAction";
import DataService from "../services/requestApi";

const AdminListing = () => {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const location = useLocation();
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();

  const pageNum = parseInt(new URLSearchParams(location.search).get("pageNum")) || 1;
  const { state } = location;
  const savedState = sessionStorage.getItem("adminListingState");
  const persistentState = state || (savedState ? JSON.parse(savedState) : {});

  useEffect(() => {
    if (state) sessionStorage.setItem("adminListingState", JSON.stringify(state));
  }, [state]);

  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [documente, setDocument] = useState(null);
  const [totalCounts, setTotalCounts] = useState(0);

  const [pageData, setPageData] = useState({
    pageNo: pageNum,
    limit: 20,
    schoolId: persistentState?.schoolId,
    vendorId: persistentState?.vendorId,
    standard: "",
  });

  const { pageNo, limit, schoolId, vendorId, standard } = pageData;

  useEffect(() => {
    setPageData(prev => ({ ...prev, pageNo: pageNum }));
  }, [pageNum]);

  useEffect(() => {
    fetchData();
  }, [pageNo, limit, standard]);

  const fetchData = async () => {
    try {
      setLoading(true);
      let query = `page=${pageNo}&limit=${limit}`;
      if (standard) query += `&standard=${standard}`;

      let response;

      if (persistentState?.role === "vendor") {
        query += `&vendorId=${vendorId}&schoolId=${schoolId}`;
        response = await CallFingerprintscanByVendorId(query);
      } else if (persistentState?.role === "user") {
        query += `&adminId=${schoolId?._id || schoolId}`;
        response = await CallGetAdminByAdminId(query);
      } else {
        query += `&adminId=${schoolId}`;
        response = await CallGetAdminByAdminId(query);
      }

      if (response?.data?.message === "Success") {
        const newData = response.data.UserData.map((item, index) => ({
          ...item,
          key: index,
        }));
        setData(newData);
        setTotalCounts(response.data.totalCount);
      } else {
        setData([]);
        setTotalCounts(0);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (id, status) => {
    try {
      const formdata = new FormData();
      formdata.append("isChecked", !status);
      const res = await CallUpdateUser(id, formdata);
      if (res?.data.message === "Success") {
        api.success({ message: res.data.message, duration: 2 });
        fetchData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const submitUploadStudentsList = e => {
    const file = e.target.files[0];
    if (
      file &&
      (file.type === "text/csv" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel")
    ) {
      setDocument(file);
    } else {
      api.warning({ message: "Please upload Excel file only", duration: 2 });
    }
  };

  const uploadExcel = async () => {
    try {
      const formdata = new FormData();
      formdata.append("school_id", persistentState?.schoolId);
      formdata.append("excel", documente);
      const res = await CallAddStudentExcel(formdata);
      if (res?.data?.message === "File uploaded/import successfully!") {
        api.success({ message: res.data.message, duration: 2 });
        setModal(false);
        fetchData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const downloadZip = async (query, fileName = `adminId=${schoolId}&standard=${standard}`) => {
    try {
      setLoading(true);
      const response = await DataService.GetReportPDF(query);
      if (!response?.data) throw new Error("No file data received.");

      const blob = new Blob([response.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${fileName}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      api.success({ message: "ZIP file downloaded successfully!", duration: 2 });
    } catch (error) {
      console.error(error);
      api.error({ message: "Failed to download ZIP file", description: error.message });
    } finally {
      setLoading(false);
    }
  };

  const getProfileLink = (id) => {
    switch (persistentState?.role) {
      case "user":
        return `/admin/user/index/user-profile/${id}`;
      case "vendor":
        return `/admin/vendor/index/user-profile/${id}`;
      case "school":
        return `/admin/school/index/user-profile/${id}`;
      default:
        return `/admin/user/index/user-profile/${id}`;
    }
  };

  return (
    <Container className="my-5" fluid>
      {contextHolder}
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0 pb-0 d-flex justify-content-between flex-wrap">
              <div className="d-flex align-items-center">
              <h3 className="mb-2 mb-sm-0">
                {persistentState?.role === "user" ? "Subuser" : "Student"} List
              </h3>
              <Card className="p-1 mb-0 ml-3 " style={{ backgroundColor: "#f7fafc" }}>
                <span id="TotalSubusers" className="mr-3 font-weight-bold">
                  Total {persistentState?.role === "user" ? "Subuser" : "Student"}: <Button color="primary" className="ml-3 mr--3" size="sm">{totalCounts}</Button>
                </span>
              </Card>
              </div>
              <div className="d-flex flex-wrap align-items-center gap-2">
                <JsonToXlsxDownload
                  jsonData={data}
                  pageName={"AdminListing"}
                  subUserId={persistentState?.schoolId}
                  standard={standard}
                />

                {persistentState?.role === "school" && (
                  <>
                    <Button color="primary" size="sm" className="px-2 py-2" onClick={() => setModal(!modal)}>
                      Upload Students Data
                    </Button>
                    <Button
                      color="primary"
                      size="sm"
                      className="py-2"
                      onClick={() =>
                        downloadZip(
                          `adminId=${schoolId}`,
                          `${data[0]?.adminId?.school_name || "school"}_${standard || "all"}`
                        )
                      }
                    >
                      Download Report
                    </Button>
                  </>
                )}

                {persistentState?.role !== "user" && (
                  <>
                    <Label className="text-dark mr-2 h5 mb-0">Class</Label>
                    <Input
                      type="select"
                      size="sm"
                      style={{ width: "80px", height: "37px", border: "1px solid #000" }}
                      value={standard || ""}
                      onChange={e => setPageData({ ...pageData, standard: e.target.value, pageNo: 1 })}
                    >
                      <option value="">All</option>
                      {[...Array(12).keys()].map(i => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </Input>
                  </>
                )}
              </div>
            </CardHeader>

            <CardBody>
              {loading ? (
                <div className="d-flex justify-content-center my-4">
                  <AntSpinner />
                </div>
              ) : data.length > 0 ? (
                <div className="table-responsive">
                  <table className="table align-items-center table-flush text-center">
                    <thead className="thead-light">
                      <tr>
                        <th>ID</th>
                        <th>Name</th>
                        {persistentState?.role !== "user" && <th>Father's Name</th>}
                        <th>Primary Personality</th>
                        <th>Secondary Personality</th>
                        <th>Mobile</th>
                        {persistentState?.role !== "user" && <th>Class</th>}
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1 + limit * (pageNo - 1)}</td>
                          <td>
                            {persistentState?.role === "user"
                              ? item.dataName
                              : `${item.firstName} ${item.lastName}`}
                          </td>
                          {persistentState?.role !== "user" && <td>{item.father_name || "--"}</td>}
                          <td>{item?.userReport?.personality?.primary || "--"}</td>
                          <td>{item?.userReport?.personality?.secondary || "--"}</td>
                          <td>{item.mobile || "--"}</td>
                          {persistentState?.role !== "user" && <td>{item.class || "--"}</td>}
                          <td>
                            <Label className="custom-toggle custom-toggle-warning">
                              <Input
                                type="checkbox"
                                defaultChecked={item.isChecked}
                                onClick={() => handleEdit(item._id, item.isChecked)}
                              />
                              <span className="custom-toggle-slider rounded-circle" />
                            </Label>
                          </td>
                          <td>
                            <Button
                              tag={Link}
                              to={getProfileLink(item._id)}
                              size="sm"
                              color="white"
                              state={{ role: persistentState.role, schoolId: persistentState.schoolId, vendorId: persistentState.vendorId }}
                            >
                              <i className="fas fa-eye text-primary" />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <h4 className="text-center my-4">No Data Found</h4>
              )}
            </CardBody>

            {totalCounts > limit && (
              <CardFooter className="text-center">
                <Pagination
                  current={pageNo}
                  pageSize={limit}
                  total={totalCounts}
                  showSizeChanger
                  showQuickJumper
                  showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                  onChange={(page, pageSize) => {
                    const params = new URLSearchParams(location.search);
                    params.set("pageNum", page);
                    navigate(`${location.pathname}?${params.toString()}`, { state: persistentState });
                    setPageData(prev => ({ ...prev, pageNo: page, limit: pageSize }));
                  }}
                />
              </CardFooter>
            )}
          </Card>
        </div>
      </Row>
      
      <Modal title="Upload Students Data" open={modal} onCancel={() => setModal(!modal)} footer={null} width={600}>
        <Input
          type="file"
          id="upload-student-list"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          onChange={submitUploadStudentsList}
        />
        <label htmlFor="upload-student-list" className="upload-student-list-label text-center my-3">
          <p><i className="fas fa-inbox display-1 text-blue" /></p>
          <p>Click or drag file to this area to upload</p>
          <p>Supports Excel file upload only</p>
        </label>
        <div className="d-flex justify-content-end">
          <Button color="primary" className="px-5" onClick={uploadExcel} disabled={!documente}>
            Upload
          </Button>
        </div>
      </Modal>
    </Container>
  );
};

export default AdminListing;